export default "__VITE_ASSET__BTqf0f04__"